import { TabPane } from 'reactstrap';
import PropTypes from 'prop-types';
import Tutor from './Tutor';

const DatosTutores = (props) => {
  const arrayTutores = props.datosTutor.datos.tutores;
  return (
    <TabPane tabId="2">
      {arrayTutores.map((tutor) => (
        <Tutor
          key={tutor.documentoTutor}
          nombre={tutor.nombreTutor}
          apellidos={`${tutor.apellido1Tutor} ${tutor.apellido2Tutor}`.trim()}
          telefono={tutor.telefonoTutor}
          dni={tutor.documentoTutor}
          email={tutor.emailTutor}
          parentesco={tutor.parentescoTutor === '(Sin Tutores)' ? '-' : tutor.parentescoTutor}
        />
      ))}
    </TabPane>
  );
};
DatosTutores.propTypes = {
  datosTutor: PropTypes.shape({
    datos: PropTypes.shape({
      tutores: PropTypes.arrayOf(PropTypes.shape({
        documentoTutor: PropTypes.string,
        nombreTutor: PropTypes.string,
        apellido1Tutor: PropTypes.string,
        apellido2Tutor: PropTypes.string,
        telefonoTutor: PropTypes.string,
        emailTutor: PropTypes.string,
        parentescoTutor: PropTypes.string,
      })),
    }),
  }).isRequired,
};
export default DatosTutores;
